import { render } from "./BuchungenList.pug?vue&type=template&id=a23b3b6e&lang=pug"
import script from "./BuchungenList.js?vue&type=script&lang=js"
export * from "./BuchungenList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__